import { createSelector } from '@ngrx/store';
import { CurrentEmpresa } from '@rpe/registro-personas-empresas-lib';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityCurrentEmpresaAdapter, EntityCurrentEmpresaState } from './entity-current-empresa.state';

const { selectEntities, selectAll } =
  entityCurrentEmpresaAdapter.getSelectors();

export const getError = (state: EntityCurrentEmpresaState): any => state.error;

export const getIsLoading = (state: EntityCurrentEmpresaState): boolean =>
  state.isLoading;

export const selectCurrentEmpresaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.currentEmpresa
);

export const selectAllCurrentEmpresa = createSelector(
  selectCurrentEmpresaState,
  selectAll
);
export const selectEntitiesCurrentEmpresa = createSelector(
  selectCurrentEmpresaState,
  selectEntities
);

export const selectCurrentEmpresa = createSelector(
  // Retorno la current empresa si existe
  selectAllCurrentEmpresa,
  (selectedEmpresas: CurrentEmpresa[]) => {
    if (selectedEmpresas) {
      return selectedEmpresas[0]
    }
    return null
  }
);

// MemoizedSelector<object,any>
export const selectCurrentEmpresaError = createSelector(
  selectCurrentEmpresaState,
  getError
);

// MemoizedSelector<object,any>
export const selectCurrentEmpresaIsLoading = createSelector(
  selectCurrentEmpresaState,
  getIsLoading
);
